import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Zones } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class ZonesModule extends VuexModule {
    @Action
    [Zones.findPageZones](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/zones/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Zones.listZones](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/zones/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Zones.saveZones](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/zones/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Zones.deleteZones](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/zones/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}